import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

function hideAppLoader() {
  const loader = document.querySelector(".loader");
  if (!loader) {
    return;
  }

  loader.style.transition = "opacity 0.3s ease";
  loader.style.opacity = "0";

  window.setTimeout(() => {
    loader.remove();
  }, 300);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

requestAnimationFrame(() => {
  requestAnimationFrame(hideAppLoader);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
